import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from '../../../../../components/ui/alert-dialog'
import { Button } from '../../../../../components/ui/button'
import { useRemoveTableCardController } from './useRemoveTableCardController'

export const RemoveTableCard = () => {
  const { handleRemoveTable, isPending, selectedTableCard } =
    useRemoveTableCardController()

  return (
    <AlertDialog>
      <AlertDialogTrigger asChild onClick={(event) => event.stopPropagation()}>
        <h2 className="text-sm font-medium">Excluir tabela</h2>
      </AlertDialogTrigger>
      <AlertDialogContent className="w-full max-w-[534px]">
        <form
          onClick={(event) => event.stopPropagation()}
          onSubmit={(event) => handleRemoveTable(event, selectedTableCard._id)}
        >
          <AlertDialogHeader>
            <AlertDialogTitle className="flex flex-col items-center gap-6 text-center">
              <i className="fa-solid fa-circle-exclamation text-6xl text-error"></i>
              <p className="text-xl font-medium">
                Você tem certeza que deseja excluir a tabela{' '}
                <span className="font-semibold">
                  &quot;{selectedTableCard.name}&quot;
                </span>
                ?
              </p>
              <p className="text-base text-black04">
                Aperte &quot;Excluir tabela&quot; para removê-la permanentemente
                ou &quot;Cancelar&quot; para manter
              </p>
            </AlertDialogTitle>
          </AlertDialogHeader>
          <AlertDialogFooter className="flex items-center">
            <AlertDialogCancel className="w-full rounded-full">
              Cancelar
            </AlertDialogCancel>
            <AlertDialogAction asChild>
              <Button
                type="submit"
                disabled={isPending}
                className="my-4 w-full rounded-full bg-primary font-bold text-white01 hover:bg-primary hover:brightness-150"
              >
                Excluir tabela
              </Button>
            </AlertDialogAction>
          </AlertDialogFooter>
        </form>
      </AlertDialogContent>
    </AlertDialog>
  )
}
